Px.CMS.PhotoPrintsComponent.Integrations.Shopify = {

  name: 'shopify',

  postMessage: function(type, data) {
    const promise = new Promise((resolve, reject) => {
      const channel = new MessageChannel();

      channel.port1.onmessage = (evt) => {
        if (evt.data.type === 'done') {
          channel.port1.close();
          resolve();
        }
      };

      const msg = {pixfizz: true, type: type, data: data || {}};
      window.parent.postMessage(msg, '*', [channel.port2]);
    });

    return promise;
  },

  createProjectExtraParams: function(print_product) {
    if (!print_product.sku) {
      console.error('Design product definition is missing the sku field', mobx.toJS(print_product));
      throw new Error('Design product does not have a sku');
    }

    const shopify_product_id = Px.urlQuery().shopify_product_id;
    if (!shopify_product_id) {
      throw new Error('shopify_product_id is not set');
    }

    const shopify_variant_id = Px.CMS.PhotoPrintsComponent.Integrations.Shopify.getShopifyVariantId(print_product.sku);
    if (!shopify_variant_id) {
      throw new Error('shopify_variant_id not set');
    }

    return {
      'custom[shopify_product_id]': shopify_product_id,
      'custom[shopify_variant_id]': shopify_variant_id
    };
  },

  getShopifyVariantId: function(pixfizz_sku) {
    const sku_map = JSON.parse(Px.urlQuery().shopify_sku_map);
    let shopify_variant_id;
    Object.entries(sku_map).forEach(entry => {
      if (entry[1] === pixfizz_sku) {
        shopify_variant_id = entry[0];
      }
    });
    return shopify_variant_id;
  },

  goToCart: function() {
    return Px.CMS.PhotoPrintsComponent.Integrations.Shopify.postMessage('goto_cart');
  },

  addProjectToCart: function(project, print_product) {
    const shopify_variant_id = project.options.shopify_variant_id;
    const shopify_addons_map = JSON.parse(Px.urlQuery().shopify_addons_map);
    const option_addons_map = shopify_addons_map[shopify_variant_id].option_addons;
    // Collect addon product info (extra pages or options that are mapped to Shopify addon products).
    const addons = Px.CMS.PhotoPrintsComponent.Integrations.Shopify._collectAddons(project, option_addons_map);
    // Collect all chosen variant and template options to set them on the shopify orderline,
    // so that they are displayed in the cart.
    const properties = Px.CMS.PhotoPrintsComponent.Integrations.Shopify._collectProjectOptionsForDisplay(
      project, print_product
    );
    // Set project id as a hidden (hence the _ prefix) property on the orderline.
    properties._pixfizz_project_id = project.id;

    const data = {
      shopify_variant_id: shopify_variant_id,
      quantity: project.cut_print_quantity,
      properties: properties,
      addons: addons,
      redirect: false
    };

    return Px.CMS.PhotoPrintsComponent.Integrations.Shopify.postMessage('add_to_cart', data);
  },

  updateCartItem: function(project, print_product) {
    const option_addons = Px.urlQuery().option_addons;
    const option_addons_map = option_addons ? JSON.parse(option_addons) : {};
    // Collect addon product info (extra pages or options that are mapped to Shopify addon products).
    const addons = Px.CMS.PhotoPrintsComponent.Integrations.Shopify._collectAddons(project, option_addons_map);
    // Collect all chosen variant and template options to set them on the shopify orderline,
    // so that they are displayed in the cart.
    const properties = Px.CMS.PhotoPrintsComponent.Integrations.Shopify._collectProjectOptionsForDisplay(
      project, print_product
    );

    const data = {
      key: Px.urlQuery().line_item_key,
      quantity: project.cut_print_quantity,
      properties: properties,
      addons: addons,
      redirect: false
    };

    return Px.CMS.PhotoPrintsComponent.Integrations.Shopify.postMessage('update_cart_item', data);
  },

  _collectProjectOptionsForDisplay: function(project, print_product) {
    const properties = {};
    // Product variants.
    Object.keys(project.options).forEach(key => {
      const option = print_product.variants.find(o => o.code === key);
      if (option) {
        let value = project.options[key];
        if (option.type === 'multiple_choice') {
          const option_value = option.values.find(v => v.code === value);
          if (option_value) {
            properties[option.name] = option_value.name;
          } else {
            properties[option.name] = value;
          }
        } else if (option.type === 'text') {
          properties[option.name] = value;
        }
      }
    });
    // Template options.
    Object.keys(project.template_options).forEach(key => {
      const option = print_product.template_options.find(o => o.code === key);
      if (option) {
        let value = project.template_options[key];
        if (option.type === 'multiple_choice') {
          const option_value = option.values.find(v => v.code === value);
          if (option_value) {
            properties[option.name] = option_value.name;
          } else {
            properties[option.name] = value;
          }
        } else if (option.type === 'text') {
          properties[option.name] = value;
        }
      }
    });
    return properties;
  },

  _collectAddons: function(project, option_addons_map) {
    const addons = [];
    if (option_addons_map) {
      Object.keys(option_addons_map).forEach(option_type_code => {
        const value = project.template_options[option_type_code] || project.options[option_type_code];
        Object.keys(option_addons_map[option_type_code]).forEach(option_value_code => {
          addons.push({
            variant_id: option_addons_map[option_type_code][option_value_code],
            quantity: (option_value_code === value) ? 1 : 0
          });
        });
      });
    }
    return addons;
  }

};
